import {ApiClientService, EntityApiService} from "@dfl/react-security";
import {ISpaceSetting} from "modules/admin/interfaces";


class SpaceSettingService extends EntityApiService<ISpaceSetting> {

    getProperty = (id:any) => ApiClientService.get(this.getPath(`/property/${id}`))
    getPropertyBySpace = (id:any, spaceId: string) => ApiClientService.get(this.getPath(`/property/${id}?space=${spaceId}`))

    updateProperty = (params:any) => ApiClientService.patch(this.getPath(`/property/${params.typo}`), params)

}

export default new SpaceSettingService('/ms-auth/api/space-settings');
